import React, { useState, useEffect } from 'react';
import Tools from '../../Tools';

const DocsBcoChile = (props) => {

    const [selectedAllDocs, setSelectedAllDocs] = useState(true);

    const toggleAllDebts = () => {
        setSelectedAllDocs(!selectedAllDocs); //variable to toggle
        if (selectedAllDocs) {
            props.documents.forEach(d => { d.selected = false; });
            props.setDebtFn(0);
        } else {
            props.documents.forEach(d => { d.selected = true; });
            //props.setDebtFn(documents.reduce((a, b) => { return a + Number(b.montoDocto); }, 0));
            props.setDebtFn(props.documents.reduce((a, b) => { return a + Number(b.ofertaCastigo); }, 0));
        }
    }

    const selectDebt = (event, doc) => {
        if (!event.target.checked) {
            doc.selected = false;
            props.setDebtFn(props.debt - Number(event.target.value));
        } else {
            doc.selected = true;
            props.setDebtFn(props.debt + Number(event.target.value));
        }
    }

    useEffect(() => {
        //onload execute ....
        const totalDebt = props.documents.reduce((a, b) => { return a + Number(b.ofertaCastigo); }, 0);
        props.setDebtFn(totalDebt);
    }, [props.documents]);

    return (
        <table className="fullWidth">
            <thead>
                <tr>
                    <th><input type="checkbox" onChange={toggleAllDebts} defaultChecked={true} /> &nbsp; Nº Documento</th>
                    <th>Producto</th>
                    <th className='right'>Monto Castigado</th>
                    <th className='right'>Monto a Pagar</th>
                    <th className='right'>Condonación</th>
                    <th className='center'>Fecha Castigo</th>
                </tr>
            </thead>
            <tbody>
                {props.documents.map((doc, index) => {
                    return (
                        <tr key={index}>
                            <td>
                                <label className="forCheckbox"><input type="checkbox" name={'ckeck' + index} value={doc.ofertaCastigo} onChange={(e) => selectDebt(e, doc)} checked={doc.selected} />{doc.numDocto}</label>
                            </td>
                            <td>{doc.tipoProducto}</td>
                            <td className="right">{Tools.fmtClAmmount(doc.deudaTotalCastigo)}</td>
                            <td className="right">{Tools.fmtClAmmount(doc.ofertaCastigo)}</td>
                            <td className="right">{((doc.ofertaCastigo * 100) / doc.deudaTotalCastigo).toFixed(2)}%</td>
                            <td className="center">{Tools.fdCL(doc.fecMinimaCastigo)}</td>
                        </tr>

                    );
                })}
            </tbody>
        </table>
    );

}

export default DocsBcoChile;